import { SquadDto } from '@scale/shared/types/expertManagement';
import { useQuery } from 'react-query';
import { fetchSquads } from 'react-scale/components/ExpertManagement/ExpertManagementPage/api';

export const useFetchSquads = (podTypeFilter?: string, enabled: boolean = true) => {
  return useQuery<SquadDto[]>(['fetchSquads', podTypeFilter], () => fetchSquads(podTypeFilter), {
    refetchOnWindowFocus: false,
    enabled,
  });
};
